export function assertValue(value: unknown, message?: string): asserts value {
  if (value === null || value === undefined) {
    const errorMessage = message
      ? `assertValue function error: ${message}`
      : 'assertValue function error';
    throw new Error(errorMessage); // TODO: consider moving logException to utils lib and use it instead captureException
  }
}
